import { Box, Center, ChakraProvider, Image, Text, useMediaQuery } from '@chakra-ui/react';
import { breakpoints, chakraTheme } from '@kolumboos/ui';
// @ts-ignore
import Script from 'react-load-script';
import AuthSwitch from './AuthSwitch';
import KolumboosLogo from './components/others/KolumboosLogo';
import config from './config';
import ResetPasswordPage from './pages/reset-password/ResetPasswordPage';
import SignUpPage from './pages/signup/SignUpPage';
import { DialogsProvider } from './state/dialogs';
import { IntlProvider } from './state/intl';
import { TitleProvider } from './state/title';
import { beesprintId, getTenantLogoUrl } from './tenants';

const RootContent: React.FC = () => {
  const { pathname } = window.location;

  if (pathname === '/signup') {
    return <SignUpPage />;
  }

  if (pathname === '/reset-password') {
    return <ResetPasswordPage />;
  }

  return <AuthSwitch />;
};

const Root: React.FC = () => {
  const [isMobile] = useMediaQuery(`(max-width: ${breakpoints.md}px)`);

  const isBeesprint = window.location.hostname.split('.')[0] === 'beesprint';

  if (isMobile) {
    return (
      <Center w="100%" h="100%">
        <Center flexDirection="column" w="76%" mb="80px">
          {isBeesprint ? (
            <Image
              h="56px"
              w="56px"
              borderRadius={28}
              mb="12px"
              src={getTenantLogoUrl(beesprintId)}
              alt={'company-logo'}
            />
          ) : (
            <Box mb="12px" w="56px" h="56px" borderRadius={28}>
              <KolumboosLogo size={56} />
            </Box>
          )}
          <Text as="h4" textAlign="center">
            The Kolumboos PMS dashboard cannot be accessed on mobile devices.
          </Text>
        </Center>
      </Center>
    );
  }

  return (
    <>
      <ChakraProvider theme={chakraTheme}>
        <IntlProvider>
          <DialogsProvider>
            <TitleProvider>
              <RootContent />
            </TitleProvider>
          </DialogsProvider>
        </IntlProvider>
      </ChakraProvider>

      <Script
        url={`https://maps.googleapis.com/maps/api/js?key=${config.mapsApiKey}&libraries=places`}
      />
    </>
  );
};

export default Root;
